export default "__VITE_ASSET__DrBRq5cU__"